import {  Image, Space, Typography } from "antd"
import './index.css'

interface ItemNotFoundProps {
    imageUrl: string;
    textDescription: string;
  };

export const ItemNotFound: React.FC<ItemNotFoundProps> = ({ imageUrl, textDescription }) => {
    return (
      <Space className="container-item-not-found">
        <Image 
          src={imageUrl} 
          width={184} 
          height={152} 
          preview={false}
        />
        <Typography.Text type="secondary" style={{ fontSize: 18 }}>
          {textDescription}
        </Typography.Text>
      </Space>
    );
  };
